import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

function EgdsStylesPlugin() {
    return {
        name: 'egds-styles',
        onBrowserWrapRootElement: function (context, next) {
            var setRootElement = context.setRootElement;
            // Adding this to log the experiment since there is no server side logging
            var fontDisplayExperimentNoop = function () { return (React.createElement(Experiment, { name: "BERNIE_CUSTOM_FONT_DISPLAY" },
                React.createElement(ExperimentControl, null),
                React.createElement(ExperimentVariant, { bucket: 1 }))); };
            setRootElement(function (RootElement) { return function (props) { return (React.createElement(React.Fragment, null,
                fontDisplayExperimentNoop(),
                React.createElement(RootElement, null, props.children))); }; });
            return next(context);
        },
    };
}

export { EgdsStylesPlugin as default };
//# sourceMappingURL=browser.js.map
